/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marker_Import_Invalid_Format_ToastInputs */



/**
* | output |
* | --- |
* | "Invalid file format. Please select a valid file format." |
*
* @param {Marker_Import_Invalid_Format_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const marker_import_invalid_format_toast = /** @type {((inputs?: Marker_Import_Invalid_Format_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marker_Import_Invalid_Format_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Format de fichier invalide. Veuillez selectionner un format valide.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ungültiges Dateiformat. Bitte wählen Sie ein gültiges Dateiformat.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Formato file non valido. Seleziona un formato file valido.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Неверный формат файла. Пожалуйста, выберите допустимый формат файла.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Formato de archivo no válido. Seleccione un formato de archivo válido.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("文件格式无效。请选择有效的文件格式。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("無効なファイル形式です。有効なファイル形式を選択してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अमान्य फ़ाइल प्रारूप। कृपया एक मान्य फ़ाइल प्रारूप चुनें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Formato de arquivo inválido. Selecione um formato de arquivo válido.")
	return /** @type {LocalizedString} */ ("Invalid file format. Please select a valid file format.")
});